import {
  Autocomplete,
  Grid,
  TextField,
  FormControl,
  TextFielDecimalNumbers,
  Checkbox,
  FormControlLabel,
  CurrencyInput,
} from "../../../../components";
import { value } from "../../../../helpers";

export default function ModeloTributacaoIS({
  grupoModeloTributacao,
  handleInputChange,
  situacaoISList,
  classificacaoISList,
  onChangeAutocomplete,
  handleCheckBox,
}) {
  return (
    <>
      <Grid container spacing={2} className='mt-2'>
        <Grid item xs={6}>
          <FormControl variant="outlined" fullWidth>
            <Autocomplete
              id="situacaoISId"
              name="situacaoISId"
              options={situacaoISList}
              autoHighlight
              getOptionLabel={(option) =>
                option ? `${option?.codigo} - ${option?.descricao}` : ""
              }
              getOptionSelected={(option, value) =>
                option?.descricao === value?.descricao
              }
              noOptionsText="Sem opções"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Situação Tributária IS"
                  variant="outlined"
                  margin="normal"
                />
              )}
              onChange={(_, newValue) => {
                onChangeAutocomplete("situacaoISId", newValue);
              }}
              value={value.autoComplete(
                situacaoISList,
                grupoModeloTributacao?.situacaoISId
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl variant="outlined" fullWidth>
            <Autocomplete
              id="classificacaoISId"
              name="classificacaoISId"
              options={classificacaoISList}
              autoHighlight
              getOptionLabel={(option) =>
                option ? `${option?.codigo} - ${option?.descricao}` : ""
              }
              getOptionSelected={(option, value) =>
                option?.descricao === value?.descricao
              }
              noOptionsText="Sem opções"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Classificação IS"
                  variant="outlined"
                  margin="normal"
                />
              )}
              onChange={(_, newValue) => {
                onChangeAutocomplete("classificacaoISId", newValue);
              }}
              value={value.autoComplete(
                classificacaoISList,
                grupoModeloTributacao?.classificacaoISId
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaIS"
            name="aliquotaIS"
            label="Alíquota IS"
            margin="normal"
            variant="outlined"
            fullWidth
            value={grupoModeloTributacao?.aliquotaIS ?? ""}
            onBlur={handleInputChange}
          />
        </Grid>
        <Grid item xs={4}>
          <CurrencyInput
            id="valorIS"
            name="valorIS"
            label="Valor IS"
            margin="normal"
            variant="outlined"
            fullWidth
            value={grupoModeloTributacao?.valorIS ?? ""}
            onBlur={handleInputChange}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} className="mt-1">
        <Grid item xs={2} className="d-flex align-items-center">
          <FormControlLabel
            control={
              <Checkbox
                checked={grupoModeloTributacao?.descontoISBase ?? false}
                onClick={handleCheckBox}
                color="primary"
                value={grupoModeloTributacao?.descontoISBase}
                name="descontoISBase"
              />
            }
            label="Desconto na base"
          />
        </Grid>
        <Grid item xs={2} className="d-flex align-items-center">
          <FormControlLabel
            control={
              <Checkbox
                checked={grupoModeloTributacao?.despesaISBase ?? false}
                onClick={handleCheckBox}
                color="primary"
                value={grupoModeloTributacao?.despesaISBase}
                name="despesaISBase"
              />
            }
            label="Despesa na base"
          />
        </Grid>
        <Grid item xs={2} className="d-flex align-items-center">
          <FormControlLabel
            control={
              <Checkbox
                checked={grupoModeloTributacao?.ipiISBase ?? false}
                onClick={handleCheckBox}
                color="primary"
                value={grupoModeloTributacao?.ipiISBase}
                name="ipiISBase"
              />
            }
            label="IPI na base"
          />
        </Grid>
        <Grid item xs={2} className="d-flex align-items-center">
          <FormControlLabel
            control={
              <Checkbox
                checked={grupoModeloTributacao?.freteISBase ?? false}
                onClick={handleCheckBox}
                color="primary"
                value={grupoModeloTributacao?.freteISBase}
                name="freteISBase"
              />
            }
            label="Frete na base"
          />
        </Grid>
        <Grid item xs={2} className="d-flex align-items-center">
          <FormControlLabel
            control={
              <Checkbox
                checked={grupoModeloTributacao?.seguroISBase ?? false}
                onClick={handleCheckBox}
                color="primary"
                value={grupoModeloTributacao?.seguroISBase}
                name="seguroISBase"
              />
            }
            label="Seguro na base"
          />
        </Grid>
      </Grid>
    </>
  );
}
